import { trustStats, aboutText } from '@/mocks/trustStats';

export default function TrustStats() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 mb-14">
            <div className="lg:w-[30%]">
              <span className="inline-block text-xs text-foreground-500 font-medium tracking-wide uppercase mb-3">
                Trusted by Community
              </span>
            </div>
            <div className="lg:w-[70%]">
              <p className="text-lg md:text-xl text-foreground-700 leading-relaxed font-body">
                {aboutText}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            {trustStats.map((stat) => (
              <div key={stat.label} className="text-center md:text-left">
                <div className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-2">
                  {stat.value}
                </div>
                <p className="text-sm text-foreground-500 leading-snug">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}